import { VOYAGER } from '@carto/react-basemaps';
import { API_VERSIONS } from '@deck.gl/carto';

export const initialState = {
  viewState: {
    latitude: 50,
    longitude: -115,
    zoom: 2.8,
    pitch: 0,
    bearing: 0,
    dragRotate: false,
  },
  basemap: VOYAGER,
  credentials: {
    accessToken: 'eyJhbGciOiJIUzI1NiJ9.eyJhIjoiYWNfYTdseXAyMTQiLCJqdGkiOiJmMGM0MzZjNCJ9.X6ZbTrnZuZoVuTQfstjGToVp6Uy-hpe9u-g_Hoh_1dQ',
    apiVersion: API_VERSIONS.V3,
    apiBaseUrl: 'https://gcp-us-east1.api.carto.com',
  },
  googleApiKey: '', // only required when using a Google Basemap
  googleMapId: '', // only required when using a Google Custom Basemap
  accountsUrl: 'http://app.carto.com/',
  // oauth: {
  //   namespace: 'http://app.carto.com/',
  //   domain: 'auth.carto.com',
  //   // clientId: 'cDDXBBgUPz14JTbh4wshZxXZh7Um4BM9', // Team
  //   clientId: 'tKy0psRBZsOYTi7Q9uNLQRNq6XxjmY3E', // T-Mobile SPECTRA
  //   organizationId: '', // organizationId is required for SSO
  //   scopes: [
  //     'read:current_user',
  //     'update:current_user',
  //     'read:connections',
  //     'write:connections',
  //     'read:maps',
  //     'write:maps',
  //     'read:account',
  //     'admin:account',
  //   ],
  //   audience: 'carto-cloud-native-api',
  //   authorizeEndPoint: 'https://carto.com/oauth2/authorize', // only valid if keeping https://localhost:3000/oauthCallback
  // },
};
